var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.field.title))]),_c('div',{staticClass:"d-flex mb-4 file-gap"},[_c('app-thumbnail',{attrs:{"file":_vm.file},on:{"delete":function($event){_vm.file = null}}}),_c('app-file-drop',{on:{"input":_vm.onInput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }